import { CultureInfo } from '../culture-info.model';
import { CultureInfoPt } from './pt';

/**
 * @ignore
 */
export const CultureInfoPtAO: CultureInfo = {
  name: 'pt-AO',
  displayName: 'português (Angola)',
  iso3LanguageCode: 'por',
  iso2LanguageCode: 'pt',
  ietfLanguageTag: 'pt-AO',
  parent: CultureInfoPt
};
